const timelineDe = {
  title: 'Kundenaktivitäten',
  add: 'Kontakt dokumentieren',
  search: 'Aktivitäten durchsuchen',
  personalOnly: 'Nur persönliche Kontakte',
  personalContact: 'Persönlicher Kontakt',
  noOutcome: 'Kein Ergebnis ausgewählt',
  created: 'Die Aktivität wurde dokumentiert.',
  createError: 'Die Aktivität konnte nicht gespeichert werden.',
  validation: 'Bitte prüfen Sie die Pflichtfelder und das Kontaktergebnis.',
  error: 'Die Kundenhistorie konnte nicht geladen werden.',
  empty: 'Für diese Auswahl sind noch keine Aktivitäten vorhanden.',
  filters: {
    all: 'Alle',
    contacts: 'Kontakte',
    planned: 'Geplant',
    documents: 'Belege',
    communication: 'Kommunikation',
    issues: 'Vorgänge',
  },
  fields: {
    type: 'Aktivitätsart',
    date: 'Datum und Uhrzeit',
    summary: 'Kurze Zusammenfassung',
    outcome: 'Ergebnis',
    note: 'Ausführliche Notiz',
  },
  types: {
    CALL_INBOUND: 'Eingehender Anruf',
    CALL_OUTBOUND: 'Ausgehender Anruf',
    CONVERSATION: 'Persönliches Gespräch',
    CALLBACK_PLANNED: 'Rückruf geplant',
    CALLBACK_COMPLETED: 'Rückruf erledigt',
    VISIT: 'Besuch',
    MEETING: 'Termin',
    NOTE: 'Gesprächsnotiz',
    QUOTE: 'Angebot',
    ORDER: 'Auftrag',
    PORTAL_ORDER: 'Portal-Bestellung',
    DELIVERY_NOTE: 'Lieferschein',
    INVOICE: 'Rechnung',
    CREDIT_NOTE: 'Gutschrift',
    CANCELLATION: 'Stornobeleg',
    EMAIL: 'E-Mail',
    COMPLAINT: 'Reklamation',
    RETURN: 'Retoure',
    TASK: 'Aufgabe',
    FOLLOW_UP: 'Wiedervorlage',
    STATUS_CHANGE: 'Statusänderung',
    OTHER: 'Sonstige Aktivität',
  },
  sources: {
    MANUAL: 'Manuell dokumentiert',
    LEGACY_NOTE: 'Bestehende Notiz',
    LEGACY_CALL: 'Bestehendes Telefonprotokoll',
    CTI: 'Telefonie',
    DOCUMENT: 'Belegwesen',
    DOCUMENT_EMAIL: 'Belegversand',
    MAIL_MESSAGE: 'E-Mail-Akte',
    CUSTOMER_PORTAL: 'Kundenportal',
    QUESTIONNAIRE: 'Fragebogen',
    SALES_TASK: 'Vertriebsaufgabe',
    SYSTEM: 'Systemprotokoll',
  },
  callStatuses: {
    RINGING: 'Klingelt',
    ANSWERED: 'Angenommen',
    MISSED: 'Verpasst',
    VOICEMAIL: 'Mailbox',
    FAILED: 'Fehlgeschlagen',
  },
};

const timelineEn = {
  title: 'Customer activities',
  add: 'Document contact',
  search: 'Search activities',
  personalOnly: 'Personal contacts only',
  personalContact: 'Personal contact',
  noOutcome: 'No outcome selected',
  created: 'The activity has been documented.',
  createError: 'The activity could not be saved.',
  validation: 'Please check the required fields and contact outcome.',
  error: 'The customer history could not be loaded.',
  empty: 'There are no activities for this selection yet.',
  filters: {
    all: 'All',
    contacts: 'Contacts',
    planned: 'Planned',
    documents: 'Documents',
    communication: 'Communication',
    issues: 'Cases',
  },
  fields: {
    type: 'Activity type',
    date: 'Date and time',
    summary: 'Short summary',
    outcome: 'Outcome',
    note: 'Detailed note',
  },
  types: {
    CALL_INBOUND: 'Inbound call',
    CALL_OUTBOUND: 'Outbound call',
    CONVERSATION: 'Personal conversation',
    CALLBACK_PLANNED: 'Callback planned',
    CALLBACK_COMPLETED: 'Callback completed',
    VISIT: 'Visit',
    MEETING: 'Meeting',
    NOTE: 'Conversation note',
    QUOTE: 'Quote',
    ORDER: 'Order',
    PORTAL_ORDER: 'Portal order',
    DELIVERY_NOTE: 'Delivery note',
    INVOICE: 'Invoice',
    CREDIT_NOTE: 'Credit note',
    CANCELLATION: 'Cancellation document',
    EMAIL: 'Email',
    COMPLAINT: 'Complaint',
    RETURN: 'Return',
    TASK: 'Task',
    FOLLOW_UP: 'Follow-up',
    STATUS_CHANGE: 'Status change',
    OTHER: 'Other activity',
  },
  sources: {
    MANUAL: 'Documented manually',
    LEGACY_NOTE: 'Existing note',
    LEGACY_CALL: 'Existing call log',
    CTI: 'Telephony',
    DOCUMENT: 'Document processing',
    DOCUMENT_EMAIL: 'Document delivery',
    MAIL_MESSAGE: 'Email record',
    CUSTOMER_PORTAL: 'Customer portal',
    QUESTIONNAIRE: 'Questionnaire',
    SALES_TASK: 'Sales task',
    SYSTEM: 'System log',
  },
  callStatuses: {
    RINGING: 'Ringing',
    ANSWERED: 'Answered',
    MISSED: 'Missed',
    VOICEMAIL: 'Voicemail',
    FAILED: 'Failed',
  },
};

const timelineEs = {
  title: 'Actividades del cliente',
  add: 'Documentar contacto',
  search: 'Buscar actividades',
  personalOnly: 'Solo contactos personales',
  personalContact: 'Contacto personal',
  noOutcome: 'Sin resultado seleccionado',
  created: 'La actividad se ha documentado.',
  createError: 'No se pudo guardar la actividad.',
  validation: 'Revise los campos obligatorios y el resultado del contacto.',
  error: 'No se pudo cargar el historial del cliente.',
  empty: 'Aún no hay actividades para esta selección.',
  filters: {
    all: 'Todas',
    contacts: 'Contactos',
    planned: 'Planificadas',
    documents: 'Documentos',
    communication: 'Comunicación',
    issues: 'Casos',
  },
  fields: {
    type: 'Tipo de actividad',
    date: 'Fecha y hora',
    summary: 'Resumen breve',
    outcome: 'Resultado',
    note: 'Nota detallada',
  },
  types: {
    CALL_INBOUND: 'Llamada entrante',
    CALL_OUTBOUND: 'Llamada saliente',
    CONVERSATION: 'Conversación personal',
    CALLBACK_PLANNED: 'Devolución de llamada planificada',
    CALLBACK_COMPLETED: 'Devolución de llamada completada',
    VISIT: 'Visita',
    MEETING: 'Cita',
    NOTE: 'Nota de conversación',
    QUOTE: 'Oferta',
    ORDER: 'Pedido',
    PORTAL_ORDER: 'Pedido del portal',
    DELIVERY_NOTE: 'Albarán',
    INVOICE: 'Factura',
    CREDIT_NOTE: 'Abono',
    CANCELLATION: 'Documento de anulación',
    EMAIL: 'Correo electrónico',
    COMPLAINT: 'Reclamación',
    RETURN: 'Devolución',
    TASK: 'Tarea',
    FOLLOW_UP: 'Seguimiento',
    STATUS_CHANGE: 'Cambio de estado',
    OTHER: 'Otra actividad',
  },
  sources: {
    MANUAL: 'Documentado manualmente',
    LEGACY_NOTE: 'Nota existente',
    LEGACY_CALL: 'Registro de llamadas existente',
    CTI: 'Telefonía',
    DOCUMENT: 'Gestión documental',
    DOCUMENT_EMAIL: 'Envío de documentos',
    MAIL_MESSAGE: 'Expediente de correo',
    CUSTOMER_PORTAL: 'Portal del cliente',
    QUESTIONNAIRE: 'Cuestionario',
    SALES_TASK: 'Tarea comercial',
    SYSTEM: 'Registro del sistema',
  },
  callStatuses: {
    RINGING: 'Sonando',
    ANSWERED: 'Contestada',
    MISSED: 'Perdida',
    VOICEMAIL: 'Buzón de voz',
    FAILED: 'Fallida',
  },
};

const timelineFr = {
  title: 'Activités client',
  add: 'Documenter un contact',
  search: 'Rechercher des activités',
  personalOnly: 'Contacts personnels uniquement',
  personalContact: 'Contact personnel',
  noOutcome: 'Aucun résultat sélectionné',
  created: 'L’activité a été documentée.',
  createError: 'L’activité n’a pas pu être enregistrée.',
  validation: 'Veuillez vérifier les champs obligatoires et le résultat du contact.',
  error: 'L’historique client n’a pas pu être chargé.',
  empty: 'Il n’y a pas encore d’activité pour cette sélection.',
  filters: {
    all: 'Toutes',
    contacts: 'Contacts',
    planned: 'Planifiées',
    documents: 'Documents',
    communication: 'Communication',
    issues: 'Dossiers',
  },
  fields: {
    type: 'Type d’activité',
    date: 'Date et heure',
    summary: 'Résumé court',
    outcome: 'Résultat',
    note: 'Note détaillée',
  },
  types: {
    CALL_INBOUND: 'Appel entrant',
    CALL_OUTBOUND: 'Appel sortant',
    CONVERSATION: 'Conversation personnelle',
    CALLBACK_PLANNED: 'Rappel planifié',
    CALLBACK_COMPLETED: 'Rappel effectué',
    VISIT: 'Visite',
    MEETING: 'Rendez-vous',
    NOTE: 'Note de conversation',
    QUOTE: 'Devis',
    ORDER: 'Commande',
    PORTAL_ORDER: 'Commande du portail',
    DELIVERY_NOTE: 'Bon de livraison',
    INVOICE: 'Facture',
    CREDIT_NOTE: 'Avoir',
    CANCELLATION: 'Document d’annulation',
    EMAIL: 'E-mail',
    COMPLAINT: 'Réclamation',
    RETURN: 'Retour',
    TASK: 'Tâche',
    FOLLOW_UP: 'Relance',
    STATUS_CHANGE: 'Changement de statut',
    OTHER: 'Autre activité',
  },
  sources: {
    MANUAL: 'Documenté manuellement',
    LEGACY_NOTE: 'Note existante',
    LEGACY_CALL: 'Journal d’appels existant',
    CTI: 'Téléphonie',
    DOCUMENT: 'Gestion documentaire',
    DOCUMENT_EMAIL: 'Envoi de document',
    MAIL_MESSAGE: 'Dossier e-mail',
    CUSTOMER_PORTAL: 'Portail client',
    QUESTIONNAIRE: 'Questionnaire',
    SALES_TASK: 'Tâche commerciale',
    SYSTEM: 'Journal système',
  },
  callStatuses: {
    RINGING: 'Sonnerie',
    ANSWERED: 'Décroché',
    MISSED: 'Manqué',
    VOICEMAIL: 'Messagerie vocale',
    FAILED: 'Échoué',
  },
};

const timelineRu = {
  title: 'Действия по клиенту',
  add: 'Зафиксировать контакт',
  search: 'Поиск действий',
  personalOnly: 'Только личные контакты',
  personalContact: 'Личный контакт',
  noOutcome: 'Результат не выбран',
  created: 'Действие зафиксировано.',
  createError: 'Не удалось сохранить действие.',
  validation: 'Проверьте обязательные поля и результат контакта.',
  error: 'Не удалось загрузить историю клиента.',
  empty: 'Для выбранных условий действий пока нет.',
  filters: {
    all: 'Все',
    contacts: 'Контакты',
    planned: 'Запланированные',
    documents: 'Документы',
    communication: 'Общение',
    issues: 'Обращения',
  },
  fields: {
    type: 'Тип действия',
    date: 'Дата и время',
    summary: 'Краткое описание',
    outcome: 'Результат',
    note: 'Подробная заметка',
  },
  types: {
    CALL_INBOUND: 'Входящий звонок',
    CALL_OUTBOUND: 'Исходящий звонок',
    CONVERSATION: 'Личная беседа',
    CALLBACK_PLANNED: 'Обратный звонок запланирован',
    CALLBACK_COMPLETED: 'Обратный звонок выполнен',
    VISIT: 'Визит',
    MEETING: 'Встреча',
    NOTE: 'Заметка о разговоре',
    QUOTE: 'Предложение',
    ORDER: 'Заказ',
    PORTAL_ORDER: 'Заказ с портала',
    DELIVERY_NOTE: 'Накладная',
    INVOICE: 'Счёт',
    CREDIT_NOTE: 'Кредит-нота',
    CANCELLATION: 'Документ отмены',
    EMAIL: 'Эл. письмо',
    COMPLAINT: 'Претензия',
    RETURN: 'Возврат',
    TASK: 'Задача',
    FOLLOW_UP: 'Повторное обращение',
    STATUS_CHANGE: 'Изменение статуса',
    OTHER: 'Другое действие',
  },
  sources: {
    MANUAL: 'Добавлено вручную',
    LEGACY_NOTE: 'Существующая заметка',
    LEGACY_CALL: 'Существующий журнал звонков',
    CTI: 'Телефония',
    DOCUMENT: 'Документооборот',
    DOCUMENT_EMAIL: 'Отправка документа',
    MAIL_MESSAGE: 'История электронной почты',
    CUSTOMER_PORTAL: 'Портал клиента',
    QUESTIONNAIRE: 'Опросник',
    SALES_TASK: 'Задача отдела продаж',
    SYSTEM: 'Системный журнал',
  },
  callStatuses: {
    RINGING: 'Вызов',
    ANSWERED: 'Принят',
    MISSED: 'Пропущен',
    VOICEMAIL: 'Голосовая почта',
    FAILED: 'Ошибка',
  },
};

const timelineTr = {
  title: 'Müşteri etkinlikleri',
  add: 'Teması belgele',
  search: 'Etkinliklerde ara',
  personalOnly: 'Yalnızca kişisel temaslar',
  personalContact: 'Kişisel temas',
  noOutcome: 'Sonuç seçilmedi',
  created: 'Etkinlik belgelendi.',
  createError: 'Etkinlik kaydedilemedi.',
  validation: 'Zorunlu alanları ve temas sonucunu kontrol edin.',
  error: 'Müşteri geçmişi yüklenemedi.',
  empty: 'Bu seçim için henüz etkinlik yok.',
  filters: {
    all: 'Tümü',
    contacts: 'Temaslar',
    planned: 'Planlanan',
    documents: 'Belgeler',
    communication: 'İletişim',
    issues: 'Kayıtlar',
  },
  fields: {
    type: 'Etkinlik türü',
    date: 'Tarih ve saat',
    summary: 'Kısa özet',
    outcome: 'Sonuç',
    note: 'Ayrıntılı not',
  },
  types: {
    CALL_INBOUND: 'Gelen arama',
    CALL_OUTBOUND: 'Giden arama',
    CONVERSATION: 'Kişisel görüşme',
    CALLBACK_PLANNED: 'Geri arama planlandı',
    CALLBACK_COMPLETED: 'Geri arama tamamlandı',
    VISIT: 'Ziyaret',
    MEETING: 'Toplantı',
    NOTE: 'Görüşme notu',
    QUOTE: 'Teklif',
    ORDER: 'Sipariş',
    PORTAL_ORDER: 'Portal siparişi',
    DELIVERY_NOTE: 'İrsaliye',
    INVOICE: 'Fatura',
    CREDIT_NOTE: 'Alacak dekontu',
    CANCELLATION: 'İptal belgesi',
    EMAIL: 'E-posta',
    COMPLAINT: 'Şikâyet',
    RETURN: 'İade',
    TASK: 'Görev',
    FOLLOW_UP: 'Takip',
    STATUS_CHANGE: 'Durum değişikliği',
    OTHER: 'Diğer etkinlik',
  },
  sources: {
    MANUAL: 'Elle belgelendi',
    LEGACY_NOTE: 'Mevcut not',
    LEGACY_CALL: 'Mevcut arama kaydı',
    CTI: 'Telefon sistemi',
    DOCUMENT: 'Belge işlemleri',
    DOCUMENT_EMAIL: 'Belge gönderimi',
    MAIL_MESSAGE: 'E-posta kaydı',
    CUSTOMER_PORTAL: 'Müşteri portalı',
    QUESTIONNAIRE: 'Anket',
    SALES_TASK: 'Satış görevi',
    SYSTEM: 'Sistem günlüğü',
  },
  callStatuses: {
    RINGING: 'Çalıyor',
    ANSWERED: 'Yanıtlandı',
    MISSED: 'Cevapsız',
    VOICEMAIL: 'Sesli mesaj',
    FAILED: 'Başarısız',
  },
};

const outcomes = {
  de: {
    REACHED: 'Erreicht',
    NOT_REACHED: 'Nicht erreicht',
    CALLBACK_REQUESTED: 'Rückruf gewünscht',
    CALLBACK_SCHEDULED: 'Rückruf geplant',
    ORDER_EXPECTED: 'Bestellung erwartet',
    QUOTE_REQUESTED: 'Angebot gewünscht',
    SAMPLE_REQUESTED: 'Muster gewünscht',
    NO_CURRENT_NEED: 'Aktuell kein Bedarf',
    CONTACT_LATER: 'Später erneut kontaktieren',
    CONTACT_CHANGED: 'Ansprechpartner nicht mehr zuständig',
    TEMPORARILY_CLOSED: 'Kunde vorübergehend geschlossen',
    CUSTOMER_LOST: 'Kunde verloren',
    INVALID_CONTACT_DATA: 'Falsche Kontaktdaten',
    COMPLAINT_OR_PROBLEM: 'Reklamation oder Problem',
    OTHER: 'Sonstiges Ergebnis',
  },
  en: {
    REACHED: 'Reached',
    NOT_REACHED: 'Not reached',
    CALLBACK_REQUESTED: 'Callback requested',
    CALLBACK_SCHEDULED: 'Callback scheduled',
    ORDER_EXPECTED: 'Order expected',
    QUOTE_REQUESTED: 'Quote requested',
    SAMPLE_REQUESTED: 'Sample requested',
    NO_CURRENT_NEED: 'No current need',
    CONTACT_LATER: 'Contact again later',
    CONTACT_CHANGED: 'Contact person no longer responsible',
    TEMPORARILY_CLOSED: 'Customer temporarily closed',
    CUSTOMER_LOST: 'Customer lost',
    INVALID_CONTACT_DATA: 'Invalid contact data',
    COMPLAINT_OR_PROBLEM: 'Complaint or problem',
    OTHER: 'Other outcome',
  },
  es: {
    REACHED: 'Contactado',
    NOT_REACHED: 'No contactado',
    CALLBACK_REQUESTED: 'Solicita devolución de llamada',
    CALLBACK_SCHEDULED: 'Devolución de llamada planificada',
    ORDER_EXPECTED: 'Pedido esperado',
    QUOTE_REQUESTED: 'Oferta solicitada',
    SAMPLE_REQUESTED: 'Muestra solicitada',
    NO_CURRENT_NEED: 'Sin necesidad actual',
    CONTACT_LATER: 'Contactar más adelante',
    CONTACT_CHANGED: 'La persona de contacto ya no es responsable',
    TEMPORARILY_CLOSED: 'Cliente cerrado temporalmente',
    CUSTOMER_LOST: 'Cliente perdido',
    INVALID_CONTACT_DATA: 'Datos de contacto incorrectos',
    COMPLAINT_OR_PROBLEM: 'Reclamación o problema',
    OTHER: 'Otro resultado',
  },
  fr: {
    REACHED: 'Joint',
    NOT_REACHED: 'Non joint',
    CALLBACK_REQUESTED: 'Rappel demandé',
    CALLBACK_SCHEDULED: 'Rappel planifié',
    ORDER_EXPECTED: 'Commande attendue',
    QUOTE_REQUESTED: 'Devis demandé',
    SAMPLE_REQUESTED: 'Échantillon demandé',
    NO_CURRENT_NEED: 'Aucun besoin actuel',
    CONTACT_LATER: 'Recontacter ultérieurement',
    CONTACT_CHANGED: 'L’interlocuteur n’est plus responsable',
    TEMPORARILY_CLOSED: 'Client temporairement fermé',
    CUSTOMER_LOST: 'Client perdu',
    INVALID_CONTACT_DATA: 'Coordonnées incorrectes',
    COMPLAINT_OR_PROBLEM: 'Réclamation ou problème',
    OTHER: 'Autre résultat',
  },
  ru: {
    REACHED: 'Связались',
    NOT_REACHED: 'Не дозвонились',
    CALLBACK_REQUESTED: 'Просит перезвонить',
    CALLBACK_SCHEDULED: 'Обратный звонок запланирован',
    ORDER_EXPECTED: 'Ожидается заказ',
    QUOTE_REQUESTED: 'Запрошено предложение',
    SAMPLE_REQUESTED: 'Запрошен образец',
    NO_CURRENT_NEED: 'Сейчас нет потребности',
    CONTACT_LATER: 'Связаться позднее',
    CONTACT_CHANGED: 'Контактное лицо больше не отвечает за вопрос',
    TEMPORARILY_CLOSED: 'Клиент временно закрыт',
    CUSTOMER_LOST: 'Клиент потерян',
    INVALID_CONTACT_DATA: 'Неверные контактные данные',
    COMPLAINT_OR_PROBLEM: 'Претензия или проблема',
    OTHER: 'Другой результат',
  },
  tr: {
    REACHED: 'Ulaşıldı',
    NOT_REACHED: 'Ulaşılamadı',
    CALLBACK_REQUESTED: 'Geri arama istendi',
    CALLBACK_SCHEDULED: 'Geri arama planlandı',
    ORDER_EXPECTED: 'Sipariş bekleniyor',
    QUOTE_REQUESTED: 'Teklif istendi',
    SAMPLE_REQUESTED: 'Numune istendi',
    NO_CURRENT_NEED: 'Şu anda ihtiyaç yok',
    CONTACT_LATER: 'Daha sonra tekrar iletişime geç',
    CONTACT_CHANGED: 'İlgili kişi artık sorumlu değil',
    TEMPORARILY_CLOSED: 'Müşteri geçici olarak kapalı',
    CUSTOMER_LOST: 'Müşteri kaybedildi',
    INVALID_CONTACT_DATA: 'İletişim bilgileri yanlış',
    COMPLAINT_OR_PROBLEM: 'Şikâyet veya sorun',
    OTHER: 'Diğer sonuç',
  },
} as const;

const cadence = {
  de: {
    title: 'Individueller Bestellrhythmus',
    error: 'Der Bestellrhythmus konnte nicht berechnet werden.',
    lastOrder: 'Letzte Bestellung',
    expectedOrder: 'Erwartete nächste Bestellung',
    typicalInterval: 'Üblicher Rhythmus',
    intervalRange: '{{min}}–{{max}} Tage',
    confidence: 'Vertrauensniveau',
    fallback:
      'Für eine individuelle Prognose reichen {{count}} Bestellungen noch nicht aus. Verwendet wird: {{source}}.',
    status: {
      NO_ORDERS: 'Noch keine Bestellung',
      INSUFFICIENT_DATA: 'Zu wenig Daten',
      ON_TRACK: 'Im Rhythmus',
      DUE_SOON: 'Bald erwartet',
      LATE: 'Leicht verspätet',
      OVERDUE: 'Reaktivierung prüfen',
      SEASONAL_PAUSE: 'Saisonpause',
      OPERATING_PAUSE: 'Betriebspause',
      ACTIVE_ORDER: 'Auftrag läuft',
      PLANNED_ORDER: 'Bestellung geplant',
      EXCLUDED: 'Ausgenommen',
    },
    confidenceLevels: { NONE: 'Keine', LOW: 'Niedrig', MEDIUM: 'Mittel', HIGH: 'Hoch' },
    sources: {
      INDIVIDUAL_HISTORY: 'individuelle Historie',
      CUSTOMER_OVERRIDE: 'Kundenvorgabe',
      CUSTOMER_GROUP_DEFAULT: 'Standard der Kundengruppe',
      TENANT_DEFAULT: 'Mandantenstandard',
      SYSTEM_DEFAULT: 'Systemstandard',
      NONE: 'keine Grundlage',
    },
    reasons: {
      NO_ORDER_HISTORY: 'Für diesen Kunden liegt noch keine gültige Bestellung vor.',
      INSUFFICIENT_HISTORY_FALLBACK:
        'Mit {{orderCount}} Bestellungen reichen die Daten noch nicht für eine individuelle Prognose; das Standardintervall von {{intervalDays}} Tagen gilt.',
      INDIVIDUAL_CADENCE:
        'Letzte Bestellung am {{lastOrderDate}}; üblicher Abstand {{intervalMinDays}}–{{intervalMaxDays}} Tage.',
      CUSTOMER_OVERRIDE:
        'Für diesen Kunden gilt ein manuelles Intervall von {{intervalDays}} Tagen.',
      EXPECTED_DATE_EXCEEDED:
        'Das erwartete Bestelldatum {{expectedNextOrderDate}} wurde um {{deviationDays}} Tage überschritten.',
      EXPECTED_SOON: 'Die nächste Bestellung wird um den {{expectedNextOrderDate}} erwartet.',
      SEASONAL_NOT_EXPECTED:
        'Saisonkunde: In den aktuellen Monaten wird keine Bestellung erwartet (aktive Monate: {{activeMonths}}).',
      CUSTOMER_OPERATING_PAUSE: 'Bekannte Betriebspause: {{pauseReason}}.',
      OPEN_ORDER_EXISTS: 'Der Auftrag {{activeOrderNumber}} wird bereits bearbeitet.',
      PLANNED_ORDER_EXISTS: 'Eine Bestellung ist für den {{plannedOrderDate}} geplant.',
      CADENCE_EXCLUDED: 'Die automatische Rhythmusanalyse ist für diesen Kunden ausgeschlossen.',
    },
  },
  en: {
    title: 'Individual reorder cadence',
    error: 'The reorder cadence could not be calculated.',
    lastOrder: 'Last order',
    expectedOrder: 'Expected next order',
    typicalInterval: 'Typical cadence',
    intervalRange: '{{min}}–{{max}} days',
    confidence: 'Confidence',
    fallback: '{{count}} orders are not enough for an individual forecast. Using: {{source}}.',
    status: {
      NO_ORDERS: 'No order yet',
      INSUFFICIENT_DATA: 'Insufficient data',
      ON_TRACK: 'On cadence',
      DUE_SOON: 'Expected soon',
      LATE: 'Slightly late',
      OVERDUE: 'Review reactivation',
      SEASONAL_PAUSE: 'Seasonal pause',
      OPERATING_PAUSE: 'Operating pause',
      ACTIVE_ORDER: 'Order in progress',
      PLANNED_ORDER: 'Order planned',
      EXCLUDED: 'Excluded',
    },
    confidenceLevels: { NONE: 'None', LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High' },
    sources: {
      INDIVIDUAL_HISTORY: 'individual history',
      CUSTOMER_OVERRIDE: 'customer override',
      CUSTOMER_GROUP_DEFAULT: 'customer-group default',
      TENANT_DEFAULT: 'organisation default',
      SYSTEM_DEFAULT: 'system default',
      NONE: 'no basis',
    },
    reasons: {
      NO_ORDER_HISTORY: 'There is no valid order for this customer yet.',
      INSUFFICIENT_HISTORY_FALLBACK:
        '{{orderCount}} orders are not enough for an individual forecast; the default interval of {{intervalDays}} days applies.',
      INDIVIDUAL_CADENCE:
        'Last order on {{lastOrderDate}}; the usual interval is {{intervalMinDays}}–{{intervalMaxDays}} days.',
      CUSTOMER_OVERRIDE: 'A manual interval of {{intervalDays}} days applies to this customer.',
      EXPECTED_DATE_EXCEEDED:
        'The expected order date {{expectedNextOrderDate}} has been exceeded by {{deviationDays}} days.',
      EXPECTED_SOON: 'The next order is expected around {{expectedNextOrderDate}}.',
      SEASONAL_NOT_EXPECTED:
        'Seasonal customer: no order is expected in the current months (active months: {{activeMonths}}).',
      CUSTOMER_OPERATING_PAUSE: 'Known operating pause: {{pauseReason}}.',
      OPEN_ORDER_EXISTS: 'Order {{activeOrderNumber}} is already being processed.',
      PLANNED_ORDER_EXISTS: 'An order is planned for {{plannedOrderDate}}.',
      CADENCE_EXCLUDED: 'Automatic cadence analysis is excluded for this customer.',
    },
  },
  es: {
    title: 'Ritmo individual de pedidos',
    error: 'No se pudo calcular el ritmo de pedidos.',
    lastOrder: 'Último pedido',
    expectedOrder: 'Próximo pedido esperado',
    typicalInterval: 'Ritmo habitual',
    intervalRange: '{{min}}–{{max}} días',
    confidence: 'Nivel de confianza',
    fallback:
      '{{count}} pedidos aún no bastan para una previsión individual. Se utiliza: {{source}}.',
    status: {
      NO_ORDERS: 'Sin pedidos',
      INSUFFICIENT_DATA: 'Datos insuficientes',
      ON_TRACK: 'En ritmo',
      DUE_SOON: 'Esperado pronto',
      LATE: 'Leve retraso',
      OVERDUE: 'Revisar reactivación',
      SEASONAL_PAUSE: 'Pausa estacional',
      OPERATING_PAUSE: 'Pausa operativa',
      ACTIVE_ORDER: 'Pedido en curso',
      PLANNED_ORDER: 'Pedido planificado',
      EXCLUDED: 'Excluido',
    },
    confidenceLevels: { NONE: 'Ninguna', LOW: 'Baja', MEDIUM: 'Media', HIGH: 'Alta' },
    sources: {
      INDIVIDUAL_HISTORY: 'historial individual',
      CUSTOMER_OVERRIDE: 'ajuste del cliente',
      CUSTOMER_GROUP_DEFAULT: 'valor del grupo de clientes',
      TENANT_DEFAULT: 'valor de la organización',
      SYSTEM_DEFAULT: 'valor del sistema',
      NONE: 'sin base',
    },
    reasons: {
      NO_ORDER_HISTORY: 'Todavía no hay ningún pedido válido para este cliente.',
      INSUFFICIENT_HISTORY_FALLBACK:
        '{{orderCount}} pedidos no bastan para una previsión individual; se aplica el intervalo estándar de {{intervalDays}} días.',
      INDIVIDUAL_CADENCE:
        'Último pedido el {{lastOrderDate}}; el intervalo habitual es de {{intervalMinDays}}–{{intervalMaxDays}} días.',
      CUSTOMER_OVERRIDE:
        'Para este cliente se aplica un intervalo manual de {{intervalDays}} días.',
      EXPECTED_DATE_EXCEEDED:
        'La fecha esperada {{expectedNextOrderDate}} se ha superado en {{deviationDays}} días.',
      EXPECTED_SOON: 'El próximo pedido se espera alrededor del {{expectedNextOrderDate}}.',
      SEASONAL_NOT_EXPECTED:
        'Cliente estacional: no se espera pedido en los meses actuales (meses activos: {{activeMonths}}).',
      CUSTOMER_OPERATING_PAUSE: 'Pausa operativa conocida: {{pauseReason}}.',
      OPEN_ORDER_EXISTS: 'El pedido {{activeOrderNumber}} ya está en curso.',
      PLANNED_ORDER_EXISTS: 'Hay un pedido planificado para el {{plannedOrderDate}}.',
      CADENCE_EXCLUDED: 'El análisis automático está excluido para este cliente.',
    },
  },
  fr: {
    title: 'Rythme individuel de commande',
    error: 'Le rythme de commande n’a pas pu être calculé.',
    lastOrder: 'Dernière commande',
    expectedOrder: 'Prochaine commande attendue',
    typicalInterval: 'Rythme habituel',
    intervalRange: '{{min}}–{{max}} jours',
    confidence: 'Niveau de confiance',
    fallback:
      '{{count}} commandes ne suffisent pas encore à une prévision individuelle. Valeur utilisée : {{source}}.',
    status: {
      NO_ORDERS: 'Aucune commande',
      INSUFFICIENT_DATA: 'Données insuffisantes',
      ON_TRACK: 'Dans le rythme',
      DUE_SOON: 'Attendue bientôt',
      LATE: 'Léger retard',
      OVERDUE: 'Examiner la réactivation',
      SEASONAL_PAUSE: 'Pause saisonnière',
      OPERATING_PAUSE: 'Fermeture temporaire',
      ACTIVE_ORDER: 'Commande en cours',
      PLANNED_ORDER: 'Commande planifiée',
      EXCLUDED: 'Exclu',
    },
    confidenceLevels: { NONE: 'Aucun', LOW: 'Faible', MEDIUM: 'Moyen', HIGH: 'Élevé' },
    sources: {
      INDIVIDUAL_HISTORY: 'historique individuel',
      CUSTOMER_OVERRIDE: 'valeur client',
      CUSTOMER_GROUP_DEFAULT: 'valeur du groupe client',
      TENANT_DEFAULT: 'valeur de l’organisation',
      SYSTEM_DEFAULT: 'valeur système',
      NONE: 'aucune base',
    },
    reasons: {
      NO_ORDER_HISTORY: 'Ce client ne possède encore aucune commande valide.',
      INSUFFICIENT_HISTORY_FALLBACK:
        '{{orderCount}} commandes ne suffisent pas à une prévision individuelle ; l’intervalle standard de {{intervalDays}} jours s’applique.',
      INDIVIDUAL_CADENCE:
        'Dernière commande le {{lastOrderDate}} ; l’intervalle habituel est de {{intervalMinDays}}–{{intervalMaxDays}} jours.',
      CUSTOMER_OVERRIDE: 'Un intervalle manuel de {{intervalDays}} jours s’applique à ce client.',
      EXPECTED_DATE_EXCEEDED:
        'La date attendue {{expectedNextOrderDate}} est dépassée de {{deviationDays}} jours.',
      EXPECTED_SOON: 'La prochaine commande est attendue vers le {{expectedNextOrderDate}}.',
      SEASONAL_NOT_EXPECTED:
        'Client saisonnier : aucune commande n’est attendue pendant les mois actuels (mois actifs : {{activeMonths}}).',
      CUSTOMER_OPERATING_PAUSE: 'Fermeture temporaire connue : {{pauseReason}}.',
      OPEN_ORDER_EXISTS: 'La commande {{activeOrderNumber}} est déjà en traitement.',
      PLANNED_ORDER_EXISTS: 'Une commande est prévue pour le {{plannedOrderDate}}.',
      CADENCE_EXCLUDED: 'L’analyse automatique du rythme est exclue pour ce client.',
    },
  },
  ru: {
    title: 'Индивидуальный ритм заказов',
    error: 'Не удалось рассчитать ритм заказов.',
    lastOrder: 'Последний заказ',
    expectedOrder: 'Ожидаемый следующий заказ',
    typicalInterval: 'Обычный ритм',
    intervalRange: '{{min}}–{{max}} дней',
    confidence: 'Уровень уверенности',
    fallback:
      '{{count}} заказов пока недостаточно для индивидуального прогноза. Используется: {{source}}.',
    status: {
      NO_ORDERS: 'Заказов ещё нет',
      INSUFFICIENT_DATA: 'Недостаточно данных',
      ON_TRACK: 'По графику',
      DUE_SOON: 'Ожидается скоро',
      LATE: 'Небольшая задержка',
      OVERDUE: 'Проверить реактивацию',
      SEASONAL_PAUSE: 'Сезонная пауза',
      OPERATING_PAUSE: 'Перерыв в работе',
      ACTIVE_ORDER: 'Заказ в работе',
      PLANNED_ORDER: 'Заказ запланирован',
      EXCLUDED: 'Исключено',
    },
    confidenceLevels: { NONE: 'Нет', LOW: 'Низкий', MEDIUM: 'Средний', HIGH: 'Высокий' },
    sources: {
      INDIVIDUAL_HISTORY: 'индивидуальная история',
      CUSTOMER_OVERRIDE: 'настройка клиента',
      CUSTOMER_GROUP_DEFAULT: 'стандарт группы клиентов',
      TENANT_DEFAULT: 'стандарт организации',
      SYSTEM_DEFAULT: 'системный стандарт',
      NONE: 'нет основания',
    },
    reasons: {
      NO_ORDER_HISTORY: 'Для этого клиента пока нет действительного заказа.',
      INSUFFICIENT_HISTORY_FALLBACK:
        '{{orderCount}} заказов недостаточно для индивидуального прогноза; применяется стандартный интервал {{intervalDays}} дней.',
      INDIVIDUAL_CADENCE:
        'Последний заказ — {{lastOrderDate}}; обычный интервал составляет {{intervalMinDays}}–{{intervalMaxDays}} дней.',
      CUSTOMER_OVERRIDE: 'Для клиента задан ручной интервал {{intervalDays}} дней.',
      EXPECTED_DATE_EXCEEDED:
        'Ожидаемая дата {{expectedNextOrderDate}} просрочена на {{deviationDays}} дней.',
      EXPECTED_SOON: 'Следующий заказ ожидается примерно {{expectedNextOrderDate}}.',
      SEASONAL_NOT_EXPECTED:
        'Сезонный клиент: в текущие месяцы заказ не ожидается (активные месяцы: {{activeMonths}}).',
      CUSTOMER_OPERATING_PAUSE: 'Известный перерыв в работе: {{pauseReason}}.',
      OPEN_ORDER_EXISTS: 'Заказ {{activeOrderNumber}} уже находится в обработке.',
      PLANNED_ORDER_EXISTS: 'Заказ запланирован на {{plannedOrderDate}}.',
      CADENCE_EXCLUDED: 'Автоматический анализ ритма отключён для этого клиента.',
    },
  },
  tr: {
    title: 'Bireysel sipariş ritmi',
    error: 'Sipariş ritmi hesaplanamadı.',
    lastOrder: 'Son sipariş',
    expectedOrder: 'Beklenen sonraki sipariş',
    typicalInterval: 'Olağan ritim',
    intervalRange: '{{min}}–{{max}} gün',
    confidence: 'Güven düzeyi',
    fallback:
      '{{count}} sipariş bireysel tahmin için henüz yeterli değil. Kullanılan değer: {{source}}.',
    status: {
      NO_ORDERS: 'Henüz sipariş yok',
      INSUFFICIENT_DATA: 'Yetersiz veri',
      ON_TRACK: 'Ritme uygun',
      DUE_SOON: 'Yakında bekleniyor',
      LATE: 'Biraz gecikti',
      OVERDUE: 'Yeniden etkinleştirmeyi incele',
      SEASONAL_PAUSE: 'Sezon arası',
      OPERATING_PAUSE: 'İşletme arası',
      ACTIVE_ORDER: 'Sipariş işleniyor',
      PLANNED_ORDER: 'Sipariş planlandı',
      EXCLUDED: 'Hariç tutuldu',
    },
    confidenceLevels: { NONE: 'Yok', LOW: 'Düşük', MEDIUM: 'Orta', HIGH: 'Yüksek' },
    sources: {
      INDIVIDUAL_HISTORY: 'bireysel geçmiş',
      CUSTOMER_OVERRIDE: 'müşteri ayarı',
      CUSTOMER_GROUP_DEFAULT: 'müşteri grubu standardı',
      TENANT_DEFAULT: 'kuruluş standardı',
      SYSTEM_DEFAULT: 'sistem standardı',
      NONE: 'dayanak yok',
    },
    reasons: {
      NO_ORDER_HISTORY: 'Bu müşteri için henüz geçerli sipariş yok.',
      INSUFFICIENT_HISTORY_FALLBACK:
        '{{orderCount}} sipariş bireysel tahmin için yeterli değil; {{intervalDays}} günlük standart aralık uygulanır.',
      INDIVIDUAL_CADENCE:
        'Son sipariş {{lastOrderDate}} tarihinde; olağan aralık {{intervalMinDays}}–{{intervalMaxDays}} gündür.',
      CUSTOMER_OVERRIDE: 'Bu müşteri için {{intervalDays}} günlük manuel aralık uygulanır.',
      EXPECTED_DATE_EXCEEDED:
        '{{expectedNextOrderDate}} beklenen sipariş tarihi {{deviationDays}} gün aşıldı.',
      EXPECTED_SOON: 'Sonraki sipariş yaklaşık {{expectedNextOrderDate}} tarihinde bekleniyor.',
      SEASONAL_NOT_EXPECTED:
        'Sezonluk müşteri: mevcut aylarda sipariş beklenmiyor (etkin aylar: {{activeMonths}}).',
      CUSTOMER_OPERATING_PAUSE: 'Bilinen işletme arası: {{pauseReason}}.',
      OPEN_ORDER_EXISTS: '{{activeOrderNumber}} numaralı sipariş zaten işleniyor.',
      PLANNED_ORDER_EXISTS: '{{plannedOrderDate}} tarihi için sipariş planlandı.',
      CADENCE_EXCLUDED: 'Bu müşteri için otomatik ritim analizi devre dışıdır.',
    },
  },
} as const;

export const salesAssistantDe = {
  timeline: timelineDe,
  outcomes: outcomes.de,
  cadence: cadence.de,
  cockpit: salesCockpitDe,
  care: salesAssistantCareDe,
  preparation: salesPreparationDe,
  ruleAdmin: salesRuleAdminDe,
  contactPreferences: salesAssistantContactPreferencesDe,
  analytics: salesAssistantAnalyticsDe,
};
export const salesAssistantEn = {
  timeline: timelineEn,
  outcomes: outcomes.en,
  cadence: cadence.en,
  cockpit: salesCockpitEn,
  care: salesAssistantCareEn,
  preparation: salesPreparationEn,
  ruleAdmin: salesRuleAdminEn,
  contactPreferences: salesAssistantContactPreferencesEn,
  analytics: salesAssistantAnalyticsEn,
};
export const salesAssistantEs = {
  timeline: timelineEs,
  outcomes: outcomes.es,
  cadence: cadence.es,
  cockpit: salesCockpitEs,
  care: salesAssistantCareEs,
  preparation: salesPreparationEs,
  ruleAdmin: salesRuleAdminEs,
  contactPreferences: salesAssistantContactPreferencesEs,
  analytics: salesAssistantAnalyticsEs,
};
export const salesAssistantFr = {
  timeline: timelineFr,
  outcomes: outcomes.fr,
  cadence: cadence.fr,
  cockpit: salesCockpitFr,
  care: salesAssistantCareFr,
  preparation: salesPreparationFr,
  ruleAdmin: salesRuleAdminFr,
  contactPreferences: salesAssistantContactPreferencesFr,
  analytics: salesAssistantAnalyticsFr,
};
export const salesAssistantRu = {
  timeline: timelineRu,
  outcomes: outcomes.ru,
  cadence: cadence.ru,
  cockpit: salesCockpitRu,
  care: salesAssistantCareRu,
  preparation: salesPreparationRu,
  ruleAdmin: salesRuleAdminRu,
  contactPreferences: salesAssistantContactPreferencesRu,
  analytics: salesAssistantAnalyticsRu,
};
export const salesAssistantTr = {
  timeline: timelineTr,
  outcomes: outcomes.tr,
  cadence: cadence.tr,
  cockpit: salesCockpitTr,
  care: salesAssistantCareTr,
  preparation: salesPreparationTr,
  ruleAdmin: salesRuleAdminTr,
  contactPreferences: salesAssistantContactPreferencesTr,
  analytics: salesAssistantAnalyticsTr,
};
import {
  salesAssistantAnalyticsDe,
  salesAssistantAnalyticsEn,
  salesAssistantAnalyticsEs,
  salesAssistantAnalyticsFr,
  salesAssistantAnalyticsRu,
  salesAssistantAnalyticsTr,
} from './sales-assistant-analytics-i18n';
import {
  salesAssistantContactPreferencesDe,
  salesAssistantContactPreferencesEn,
  salesAssistantContactPreferencesEs,
  salesAssistantContactPreferencesFr,
  salesAssistantContactPreferencesRu,
  salesAssistantContactPreferencesTr,
} from './sales-assistant-contact-preferences-i18n';
import {
  salesCockpitDe,
  salesCockpitEn,
  salesCockpitEs,
  salesCockpitFr,
  salesCockpitRu,
  salesCockpitTr,
} from './sales-assistant-cockpit-i18n';
import {
  salesAssistantCareDe,
  salesAssistantCareEn,
  salesAssistantCareEs,
  salesAssistantCareFr,
  salesAssistantCareRu,
  salesAssistantCareTr,
} from './sales-assistant-care-i18n';
import {
  salesPreparationDe,
  salesPreparationEn,
  salesPreparationEs,
  salesPreparationFr,
  salesPreparationRu,
  salesPreparationTr,
} from './sales-assistant-preparation-i18n';
import {
  salesRuleAdminDe,
  salesRuleAdminEn,
  salesRuleAdminEs,
  salesRuleAdminFr,
  salesRuleAdminRu,
  salesRuleAdminTr,
} from './sales-rule-admin-i18n';
